// ============================================================
// Shared media-localisation: supported narration languages.
//
// Extracted from apps/tours/services/agentGuide.ts so 360Tours and
// Rehub Record share ONE language list. Do not fork this list —
// tours re-exports it as AGENT_LANGUAGES.
// ============================================================

export interface MediaLanguageOption {
    /** ISO 639-1 code (ElevenLabs `language_code`). */
    code: string;
    /** English name shown in the picker. */
    label: string;
    /** Endonym shown alongside for clarity. */
    native: string;
    /** Emoji flag representing the language (most-associated country). */
    flag: string;
}

export const MEDIA_LANGUAGES: MediaLanguageOption[] = [
    { code: 'en', label: 'English', native: 'English', flag: '🇬🇧' },
    { code: 'es', label: 'Spanish', native: 'Español', flag: '🇪🇸' },
    { code: 'fr', label: 'French', native: 'Français', flag: '🇫🇷' },
    { code: 'de', label: 'German', native: 'Deutsch', flag: '🇩🇪' },
    { code: 'it', label: 'Italian', native: 'Italiano', flag: '🇮🇹' },
    { code: 'pt', label: 'Portuguese', native: 'Português', flag: '🇵🇹' },
    { code: 'nl', label: 'Dutch', native: 'Nederlands', flag: '🇳🇱' },
    { code: 'pl', label: 'Polish', native: 'Polski', flag: '🇵🇱' },
    { code: 'sv', label: 'Swedish', native: 'Svenska', flag: '🇸🇪' },
    { code: 'da', label: 'Danish', native: 'Dansk', flag: '🇩🇰' },
    { code: 'tr', label: 'Turkish', native: 'Türkçe', flag: '🇹🇷' },
    { code: 'el', label: 'Greek', native: 'Ελληνικά', flag: '🇬🇷' },
    { code: 'ar', label: 'Arabic', native: 'العربية', flag: '🇸🇦' },
    { code: 'hi', label: 'Hindi', native: 'हिन्दी', flag: '🇮🇳' },
    { code: 'ja', label: 'Japanese', native: '日本語', flag: '🇯🇵' },
    { code: 'ko', label: 'Korean', native: '한국어', flag: '🇰🇷' },
    { code: 'zh', label: 'Chinese (Mandarin)', native: '中文', flag: '🇨🇳' },
    { code: 'ru', label: 'Russian', native: 'Русский', flag: '🇷🇺' },
];

export const DEFAULT_LANGUAGE_CODE = 'en';

/** Emoji flag for a language code (empty string if unknown). */
export const languageFlagFor = (code: string): string =>
    MEDIA_LANGUAGES.find((l) => l.code === code.toLowerCase())?.flag ?? '';

/** English label for a language code (falls back to the code itself). */
export const languageLabelFor = (code: string): string =>
    MEDIA_LANGUAGES.find((l) => l.code === code.toLowerCase())?.label ?? code;

export const isSupportedLanguage = (code: string): boolean =>
    MEDIA_LANGUAGES.some((l) => l.code === code.toLowerCase());
